import { HUNDRED } from '@constants';

export const calculatePercentage = (value: number, percentage: number) => (value * percentage) / HUNDRED;
